import { PawPrint, Heart } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 9: Efekt domina - pokaż jak jedno udostępnienie uruchamia łańcuch pomocy
 */
export const InstagramStoryShare9 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Top accent */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "8px",
          background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)",
          zIndex: 2,
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "200px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Main headline */}
        <h1
          style={{
            fontSize: "88px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 48px",
            textAlign: "center",
            lineHeight: 1.15,
          }}
        >
          Nie musisz
          <br />
          adoptować,
          <br />
          żeby pomóc
        </h1>

        {/* Divider */}
        <div
          style={{
            width: "100px",
            height: "6px",
            background: "#4E8A6E",
            borderRadius: "3px",
            marginBottom: "48px",
          }}
        />

        {/* Steps - vertical chain */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginBottom: "56px",
            alignItems: "center",
          }}
        >
          {[
            { step: "Udostępnij tę stronę", icon: "📲" },
            { step: "Twój znajomy zobaczy schronisko w okolicy", icon: "📍" },
            { step: "Może zostanie wolontariuszem", icon: "🙌" },
            { step: "Albo adoptuje zwierzaka", icon: "🐾" },
          ].map((item, i) => (
            <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div
                style={{
                  background: "rgba(255,255,255,0.95)",
                  borderRadius: "24px",
                  padding: "24px 48px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  width: "820px",
                }}
              >
                <span style={{ fontSize: "44px" }}>{item.icon}</span>
                <p
                  style={{
                    fontSize: "34px",
                    fontWeight: 700,
                    color: "#2D5A3D",
                    margin: 0,
                  }}
                >
                  {item.step}
                </p>
              </div>
              {i < 3 && (
                <div
                  style={{
                    width: "4px",
                    height: "20px",
                    background: "#4E8A6E",
                    borderRadius: "2px",
                  }}
                />
              )}
            </div>
          ))}
        </div>

        {/* Bottom message */}
        <p
          style={{
            fontSize: "42px",
            fontWeight: 700,
            color: "#3D6B52",
            margin: "0 0 48px",
            textAlign: "center",
            lineHeight: 1.4,
          }}
        >
          Wszystko zaczyna się
          <br />
          od jednego kliknięcia 💚
        </p>

        {/* CTA */}
        <div
          style={{
            background: "#4E8A6E",
            borderRadius: "50px",
            padding: "24px 56px",
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Heart style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
          <p
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#FFFFFF",
              margin: 0,
            }}
          >
            Udostępnij dalej
          </p>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "0 80px 100px",
          display: "flex",
          justifyContent: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "52px",
              height: "52px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>
            gdzieschronisko.pl
          </span>
        </div>
      </div>
    </div>
  );
};
